<template>
  <div class="cashier-page">
    <!-- Header -->
    <div class="cashier-header">
      <van-icon name="arrow-left" class="back-icon" @click="$router.back()" />
      <span>收银台</span>
    </div>

    <!-- Order Info -->
    <div class="order-info">
      <div class="order-title">{{ orderTitle }}</div>
      <div class="order-amount">¥{{ amount }}</div>
    </div>

    <!-- Payment Methods -->
    <div class="payment-methods">
      <div class="section-title">选择支付方式</div>
      
      <div 
        class="payment-option" 
        @click="confirmPay"
      >
        <div class="option-left">
          <img :src="require('../assets/alipay_v2.jpg')" class="payment-icon" />
          <span class="option-name">支付宝支付</span>
        </div>
        <van-icon name="arrow" class="arrow-icon" />
      </div>
    </div>

    <!-- Footer Notice -->
    <div class="footer-notice">
      <van-icon name="shield-o" />
      支付环境安全，请放心支付
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cashier',
  data() {
    return {
      selectedMethod: 'alipay', // Default selection
      amount: 0,
      orderTitle: '',
      type: '',
      videoId: null,

    }
  },
  created() {
    // Get params from route query
    this.amount = this.$route.query.amount || 0;
    this.orderTitle = this.$route.query.title || '视频购买';
    this.type = this.$route.query.type || 'single';
    this.videoId = this.$route.query.videoId || null;

  },
  methods: {
    async confirmPay() {
      // 跳转到支付处理页面
      this.$router.push({
        path: '/payment-processing',
        query: {
          amount: this.amount,
          type: this.type,
          method: 'alipay',
          videoId: this.videoId,
          title: this.orderTitle
        }
      });
    }
  }
}
</script>

<style scoped>
.cashier-page {
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  min-height: 100vh;
  color: #fff;
  padding-bottom: 40px;
}

.cashier-header {
  display: flex;
  align-items: center;
  padding: 15px;
  font-size: 18px;
  font-weight: bold;
  background: rgba(0,0,0,0.3);
}

.back-icon {
  margin-right: 15px;
  font-size: 22px;
}

.order-info {
  text-align: center;
  padding: 30px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  margin: 15px;
  border-radius: 12px;
}

.order-title {
  font-size: 16px;
  margin-bottom: 10px;
  opacity: 0.9;
}

.order-amount {
  font-size: 36px;
  font-weight: bold;
}

.payment-methods {
  margin: 20px 15px;
}

.section-title {
  font-size: 14px;
  color: #aaa;
  margin-bottom: 15px;
}

.payment-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(255,255,255,0.1);
  padding: 20px;
  border-radius: 12px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.payment-option:active {
  background: rgba(255,255,255,0.2);
  transform: scale(0.98);
}

.option-left {
  display: flex;
  align-items: center;
}

.payment-icon {
  width: 64px;
  height: 64px;
  margin-right: 15px;
  object-fit: contain;
}

.option-name {
  font-size: 18px;
  font-weight: bold;
}

.arrow-icon {
  color: #aaa;
  font-size: 20px;
}

.footer-notice {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  color: #666;
  font-size: 12px;
}

.footer-notice .van-icon {
  margin-right: 5px;
}
</style>
